import React from 'react'
import { checkTextTranslation } from '../../utils/useful'

class NumberInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        let maxValue = this.props.header.information?.maxValue
        if (maxValue != null) {
            if (Number(value) > Number(maxValue)) {
                return
            }
        }
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value != '' ? value : null, this.props.extra)
        }
    }


    render() {
        return (
            <div className="w-100 h-100">
                <input disabled={this.props.header.information.disabled} autoFocus={this.props.header.information.autoFocus} ref={el => this.input = el} type="number" step="any" value={this.props.data != null ? this.props.data : ''} maxLength={this.props.header.information.maxLength} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} className="transpanet-input" />
            </div>
        )
    }
}

export default NumberInput;